import React, { useState } from 'react';

const InputForm = ({ onSubmit, isCalculating }) => {
  const [email, setEmail] = useState('');
  const [salaryWoInvestment, setSalaryWoInvestment] = useState(100000);
  const [salaryWInvestment, setSalaryWInvestment] = useState(100000);
  const [annualRaiseWoInvestment, setAnnualRaiseWoInvestment] = useState(3);
  const [annualRaiseWInvestment, setAnnualRaiseWInvestment] = useState(3);
  const [promotionFreqWoInvestment, setPromotionFreqWoInvestment] = useState(5);
  const [promotionFreqWInvestment, setPromotionFreqWInvestment] = useState(4.5);
  const [promotionRaiseWoInvestment, setPromotionRaiseWoInvestment] = useState(12);
  const [promotionRaiseWInvestment, setPromotionRaiseWInvestment] = useState(12);
  const [coachingInvestment, setCoachingInvestment] = useState(1000);
  const [discountRate, setDiscountRate] = useState(6);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      email,
      salary_wo_investment: salaryWoInvestment,
      salary_w_investment: salaryWInvestment,
      annualRaise_wo_investment: annualRaiseWoInvestment,
      annualRaise_w_investment: annualRaiseWInvestment,
      promotionFreq_wo_investment: promotionFreqWoInvestment,
      promotionFreq_w_investment: promotionFreqWInvestment,
      promotionRaise_wo_investment: promotionRaiseWoInvestment,
      promotionRaise_w_investment: promotionRaiseWInvestment,
      coachingInvestment,
      discountRate
    };
    console.log('Form Data Submitted:', formData);
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: '400px', margin: '0 auto', fontSize: '14px' }}>
      <div style={{ marginBottom: '0' }}>
        <label style={{ display: 'block', marginBottom: '5px' }}>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{ width: '100%', padding: '8px', fontSize: '14px' }}
        />
      </div>

      {/* Custom Input Sliders with 70/30 Width Distribution (Values/Labels + Sliders) */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0' }}>
        <div style={{ flex: 7, textAlign: 'right', paddingRight: '10px' }}>
          Salary without Investment: ${salaryWoInvestment}
        </div>
        <input
          type="range"
          min="0"
          max="500000"
          step="1000"
          value={salaryWoInvestment}
          onChange={(e) => setSalaryWoInvestment(parseFloat(e.target.value))}
          style={{ flex: 3 }}
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0' }}>
        <div style={{ flex: 7, textAlign: 'right', paddingRight: '10px' }}>
          Salary with Investment: ${salaryWInvestment}
        </div>
        <input
          type="range"
          min="0"
          max="500000"
          step="1000"
          value={salaryWInvestment}
          onChange={(e) => setSalaryWInvestment(parseFloat(e.target.value))}
          style={{ flex: 3 }}
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0' }}>
        <div style={{ flex: 7, textAlign: 'right', paddingRight: '10px' }}>
          Annual Raise without Investment: {annualRaiseWoInvestment}%
        </div>
        <input
          type="range"
          min="0"
          max="20"
          step="0.1"
          value={annualRaiseWoInvestment}
          onChange={(e) => setAnnualRaiseWoInvestment(parseFloat(e.target.value))}
          style={{ flex: 3 }}
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0' }}>
        <div style={{ flex: 7, textAlign: 'right', paddingRight: '10px' }}>
          Annual Raise with Investment: {annualRaiseWInvestment}%
        </div>
        <input
          type="range"
          min="0"
          max="20"
          step="0.1"
          value={annualRaiseWInvestment}
          onChange={(e) => setAnnualRaiseWInvestment(parseFloat(e.target.value))}
          style={{ flex: 3 }}
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0' }}>
        <div style={{ flex: 7, textAlign: 'right', paddingRight: '10px' }}>
          Promotion Frequency without Investment (years): {promotionFreqWoInvestment}
        </div>
        <input
          type="range"
          min="1"
          max="20"
          step="0.1"
          value={promotionFreqWoInvestment}
          onChange={(e) => setPromotionFreqWoInvestment(parseFloat(e.target.value))}
          style={{ flex: 3 }}
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0' }}>
        <div style={{ flex: 7, textAlign: 'right', paddingRight: '10px' }}>
          Promotion Frequency with Investment (years): {promotionFreqWInvestment}
        </div>
        <input
          type="range"
          min="1"
          max="20"
          step="0.1"
          value={promotionFreqWInvestment}
          onChange={(e) => setPromotionFreqWInvestment(parseFloat(e.target.value))}
          style={{ flex: 3 }}
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0' }}>
        <div style={{ flex: 7, textAlign: 'right', paddingRight: '10px' }}>
          Promotion Raise without Investment: {promotionRaiseWoInvestment}%
        </div>
        <input
          type="range"
          min="0"
          max="50"
          step="0.1"
          value={promotionRaiseWoInvestment}
          onChange={(e) => setPromotionRaiseWoInvestment(parseFloat(e.target.value))}
          style={{ flex: 3 }}
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0' }}>
        <div style={{ flex: 7, textAlign: 'right', paddingRight: '10px' }}>
          Promotion Raise with Investment: {promotionRaiseWInvestment}%
        </div>
        <input
          type="range"
          min="0"
          max="50" 
          step="0.1"
          value={promotionRaiseWInvestment}
          onChange={(e) => setPromotionRaiseWInvestment(parseFloat(e.target.value))}
          style={{ flex: 3 }}
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0' }}>
        <div style={{ flex: 7, textAlign: 'right', paddingRight: '10px' }}>
          Career Investment: ${coachingInvestment}
        </div>
        <input
          type="range"
          min="0"
          max="200000"
          step="100"
          value={coachingInvestment}
          onChange={(e) => setCoachingInvestment(parseFloat(e.target.value))}
          style={{ flex: 3 }}
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0' }}>
        <div style={{ flex: 7, textAlign: 'right', paddingRight: '10px' }}>
          Discount Rate: {discountRate}%
        </div>
        <input
          type="range"
          min="0"
          max="20"
          step="0.1"
          value={discountRate}
          onChange={(e) => setDiscountRate(parseFloat(e.target.value))}
          style={{ flex: 3 }}
        />
      </div>

      <button
        type="submit"
        style={{
          width: '100%',
          padding: '10px',
          backgroundColor: isCalculating ? 'yellow' : '#4CAF50',
          color: isCalculating ? 'black' : 'white',
          border: 'none',
          cursor: isCalculating ? 'default' : 'pointer',
          fontSize: '14px'
        }}
        disabled={isCalculating} // Disable the button while calculating
      >
        {isCalculating ? 'Calculating... This may take a few seconds.' : 'Submit'}
      </button>
    </form>
  );
};

export default InputForm;